import {
  AD_TYPES,
  GOALS,
  WALMART_SELLER_DOUBLE_CAMPAIGN_MIN_BUDGET,
  WALMART_SELLER_SINGLE_CAMPAIGN_MIN_BUDGET,
  WALMART_VENDOR_SINGLE_CAMPAIGN_MIN_BUDGET,
  WALMART_VENDOR_DOUBLE_CAMPAIGN_MIN_BUDGET,
} from "components/core/blocks/AdPlan/constants";
import { useAppSelector } from "../../../../redux/hooks";

export const getWalmartBudgetMinimum = (
  adType: number,
  goal: number,
  organizationType: string | null,
  autoCampaignEnabled?: boolean,
) => {
  const isSponsoredProductAdType = [
    AD_TYPES.SPONSORED_PRODUCT_WALMART.value,
    AD_TYPES.SPONSORED_PRODUCT.value,
  ].includes(adType);

  let minBudgetRequirement;

  if (organizationType === "vendor") {
    if (isSponsoredProductAdType && goal !== GOALS.SOV.value && autoCampaignEnabled) {
      minBudgetRequirement = WALMART_VENDOR_DOUBLE_CAMPAIGN_MIN_BUDGET;
    } else {
      minBudgetRequirement = WALMART_VENDOR_SINGLE_CAMPAIGN_MIN_BUDGET;
    }
  }
  if (organizationType === "seller") {
    if (isSponsoredProductAdType && goal !== GOALS.SOV.value && autoCampaignEnabled) {
      minBudgetRequirement = WALMART_SELLER_DOUBLE_CAMPAIGN_MIN_BUDGET;
    } else {
      minBudgetRequirement = WALMART_SELLER_SINGLE_CAMPAIGN_MIN_BUDGET;
    }
  }

  return minBudgetRequirement;
};

export function useDailyBudgetMinimum(ad: { ad_type: number; ad_goal: number; auto_campaign_enabled: boolean }) {
  const channel = useAppSelector((state) => state.channel.currentChannel);
  const orgType = useAppSelector((state) => state.user.organization_type);
  switch (channel) {
    case "walmart":
      return getWalmartBudgetMinimum(ad.ad_type, ad.ad_goal, orgType, ad.auto_campaign_enabled);
    default:
      return 0;
  }
}

// This looks weird
// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const getCreativeAssetId = (useNewCreativeFormat?: boolean, adPlanData?: any) => {
  const creativeData = adPlanData?.data?.creative?.properties?.[0]?.creative;
  const fallbackAssets = adPlanData?.data?.creative?.properties;

  let creativeAsset;

  if (useNewCreativeFormat) {
    const customImages = creativeData?.customImages;

    // Handle the current format for ExtendedProductCollection
    if (Array.isArray(customImages) && customImages.length > 0) {
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      creativeAsset = (customImages[0] as any)?.assetId;
    } else {
      // Handle SB V2 format
      creativeAsset = creativeData?.customImageAssetId;
    }
  } else {
    // Handle SD and SBV custom creatives
    creativeAsset =
      fallbackAssets?.rectCustomImage?.assetId ||
      fallbackAssets?.squareCustomImage?.assetId ||
      adPlanData?.data?.creative?.customImageAssetId ||
      fallbackAssets?.video?.assetId;
  }

  return creativeAsset;
};

type SavedCampaignNames = {
  savedManualCampaignName?: string;
  savedAutoCampaignName?: string;
  savedContextualCampaignName?: string;
  savedAudienceCampaignName?: string;
};

export const updateSavedCampaignNames = (
  campaignNames: {
    manual_name?: string;
    auto_name?: string;
    contextual_name?: string;
    audience_name?: string;
  },
  onChange: (savedCampaignNames: SavedCampaignNames) => void,
) => {
  const savedCampaignNames: SavedCampaignNames = {};

  if (campaignNames.manual_name) {
    savedCampaignNames.savedManualCampaignName = campaignNames.manual_name;
  }
  if (campaignNames.auto_name) {
    savedCampaignNames.savedAutoCampaignName = campaignNames.auto_name;
  }
  if (campaignNames.contextual_name) {
    savedCampaignNames.savedContextualCampaignName = campaignNames.contextual_name;
  }
  if (campaignNames.audience_name) {
    savedCampaignNames.savedAudienceCampaignName = campaignNames.audience_name;
  }

  onChange(savedCampaignNames);
};

export const roasToAcos = (roas: number) => {
  return roas ? (1 / roas) * 100 : 0;
};

export const acosToRoas = (acos: number) => {
  return acos ? +((1 / acos) * 100).toFixed(2) : 0;
};
